import { InlineAlert } from '@xo-union/tk-component-alerts';
import { Button } from '@xo-union/tk-component-buttons';
import Modal, { ModalHeader } from '@xo-union/tk-component-modals';
import { Form, Formik } from 'formik';
import Honeybadger from 'honeybadger-js';
import React from 'react';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import { Maybe, useUpdateMemberNamesMutation } from '../../generated/graphql';
import NameFormSection from '../BasicInfoRail/NameFormSection';
import styles from './messages.scss';

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  fianceFirstName: Yup.string().required('Partner First Name is required'),
  fianceLastName: Yup.string().required('Partner Last Name is required'),
});

interface Props {
  firstName?: Maybe<string>;
  lastName?: Maybe<string>;
  fianceFirstName?: Maybe<string>;
  fianceLastName?: Maybe<string>;
}

interface Initial {
  firstName: string;
  lastName: string;
  fianceFirstName: string;
  fianceLastName: string;
}

const NameModal: React.FC<Props> = ({ firstName, lastName, fianceFirstName, fianceLastName }) => {
  const [updateNames, { error }] = useUpdateMemberNamesMutation();
  const history = useHistory();

  const onSubmit = async (values: Initial) => {
    try {
      await updateNames({
        variables: {
          membersArgs: values,
        },
      });
    } catch (error) {
      Honeybadger.notify('Error updating names', {
        contxt: {
          error,
        },
      });
    }
  };

  const initialValues: Initial = {
    firstName: firstName || '',
    lastName: lastName || '',
    fianceFirstName: fianceFirstName || '',
    fianceLastName: fianceLastName || '',
  };

  return (
    <Modal
      size="md"
      onCloseButtonClick={history.goBack}
      onOverlayClick={() => {
        /* don't close modal by clicking outside it */
      }}
    >
      {error && <InlineAlert type="error">Something went wrong</InlineAlert>}
      <ModalHeader>Add Your Names to Send Messages</ModalHeader>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
        {({ submitForm, isSubmitting }) => (
          <Form>
            <NameFormSection />
            <Button
              onClick={submitForm}
              disabled={isSubmitting}
              data-testid="save-name-button"
              className={styles.nameButton}
              size="md"
              type="submit"
            >
              Save
            </Button>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default NameModal;
